import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';

@Entity('m_operator')
export class OperatorEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'operator_id'
    })
    operatorId: string;

    @Column('varchar', {
        nullable: false,
        length: 15,
        name: 'operator_rf_id',
        default: ''
    })
    operatorRfId: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'operator_name',
        default: ''
    })
    operatorName: string;

    @Column('varchar', {
        nullable: true,
        length: 50,
        name: 'operator_desc',
        default: ''
    })
    operatorDesc: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'line_id'
    })
    lineId: string;

    @Column('varchar',{
        nullable:false,
        length: 10,
        name:'unit_id'
    })
    unitId: string;

    @Column('boolean',{
        nullable:false,
        default: true,
        name:'is_active'
    })
    isActive:boolean;

    @CreateDateColumn({name: 'created_at'})
    createdAt: Date;

    @UpdateDateColumn({name: 'updated_at'})
    updatedAt: Date;
}